import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowPathDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"arrow-path-down"} maskId="square-filled-radius-0-stroke-1-IconArrowPathDown"><path d="M3.41309 12.9817H8.0002V1.9817H16.0002V12.9817H20.5873L12.0002 23L3.41309 12.9817Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconArrowPathDown;
